'use client'
import { ValueWithUnit, PaymentType, ToDateTime } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { AgentOTCTransaction } from '@repo/services'
import {
  Button,
  Col,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTrigger,
  Row,
  Typography,
} from '@repo/ui/components'
import { useState } from 'react'

interface HistoryDetailsDialogProps extends AgentOTCTransaction {
  children: React.ReactNode
}

export const HistoryDetailsDialog = (props: HistoryDetailsDialogProps) => {
  const { children, order, agentAmount, createdAt } = props
  const { t } = useTranslate()

  const [open, setOpen] = useState(false)

  const title = order?.orderType ? t('history_buy') : t('history_sell')

  const handleBack = () => {
    setOpen(false)
  }

  return (
    <Modal open={open} onOpenChange={setOpen}>
      <ModalTrigger asChild>{children}</ModalTrigger>
      <ModalContent className='sm:max-w-[425px]'>
        <ModalHeader>
          <ModalTitle
            className={
              order?.orderType === 'buy'
                ? 'text-positive-surface-100'
                : 'text-negative-surface-100'
            }
          >
            {title}
          </ModalTitle>
        </ModalHeader>

        <Row className='justify-between'>
          <Typography className='flex-1'>{t('common_time')}</Typography>
          <Typography className='text-neutral-surface-80' variant='bdi'>
            <ToDateTime date={new Date(createdAt ?? '')} />
          </Typography>
        </Row>
        <Row className='justify-between'>
          <Typography className='flex-1'>{t('history_income')}</Typography>
          <PaymentType value={agentAmount} />
        </Row>
        <Row className='justify-between'>
          <Typography className='flex-1'>{t('history_amount')}</Typography>
          <Typography className='text-neutral-surface-80' variant='bdi'>
            <ValueWithUnit
              value={order?.targetAmount ?? 0}
              unitSize='sm'
              valueSize='sm'
              unit='property'
            />
          </Typography>
        </Row>

        <ModalFooter className='flex flex-col gap-md'>
          <Button
            variant='ghost'
            width='full'
            size='md'
            color='neutral'
            onClick={handleBack}
          >
            {t('common_back')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
